/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import { GETTER_MINI_SPECIALITEM_INFO } from '@/store/mutation_types';
import XImg from '@/components/XImg';
export default {
  data: function data() {
    return {
      specialItemList: [],
      specialitemdes: ''
    };
  },
  components: {
    XImg: XImg
  },
  created: function created() {
    this.specialitemdes = this.specialItem.SPECIALITEMDES.split('\n').join('<br/>');
    console.log(this.specialitemdes); // this.getSpecialItemListAjax();
  },
  mounted: function mounted() {},
  computed: _objectSpread({}, mapGetters({
    specialItem: 'GETTER_MINI_SPECIALITEM_INFO'
  })),
  methods: {}
};